/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JiraInvitePeopleModalContextProvider } from '@jira/project-settings__invite-people-modal-context/src/JiraInvitePeopleModalContextProvider.tsx';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';
import { TeamsMenu } from './ui/index.tsx';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const Teams = (props: Props): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-teams">
		<JSErrorBoundary fallback="flag" id="teams" packageName={PACKAGE_NAME} teamName={TEAM_NAME}>
			<JiraInvitePeopleModalContextProvider
				renderedInProjectContext={false}
				shouldDisplaySuccessModal={false}
			>
				<TeamsMenu {...props} />
			</JiraInvitePeopleModalContextProvider>
		</JSErrorBoundary>
	</UFOSegment>
);
